import {ReactNode} from 'react';
import {ITreeItemData, ITreeProps, Svg, TREE_ROOT_ITEM_ID, TTree} from '@progress-fe/ui-kit';
import {ElementIcon, LogicalElementIcon, RFSvg} from '@progress-fe/rf-core';
import {EElement, ELogicalElement, EStructureItem} from '@progress-fe/core';

export const castTrees = (trees: Array<TTree>): Array<ITreeProps<ITreeItemData>> => {
  return trees.map((treeItems, i) => {
    const data = treeItems[TREE_ROOT_ITEM_ID].data;

    let treeIcon: ReactNode | undefined = undefined;
    if (data.entityType === EStructureItem.Element) {
      treeIcon = <RFSvg name={ElementIcon[data.entitySubType as EElement]} />;
    }
    if (data.entityType === EStructureItem.LogicalElement) {
      treeIcon = <RFSvg name={LogicalElementIcon[data.entitySubType as ELogicalElement]} />;
    }
    if (data.entityType === EStructureItem.Dataset) {
      treeIcon = <Svg name={'Table'} />;
    }

    return {
      treeId: data.entityUuid ?? i.toString(),
      treeName: data.entityName ?? '-',
      treeType: data.entityType ?? EStructureItem.Element,
      treeIcon: treeIcon,
      treeItems: treeItems
    };
  });
};
